module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DelayLink = void 0;

  var r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      o = l(n(1)),
      i = l(n(2)),
      u = n(5);

  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var a = t.DelayLink = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.timeout = null, n.handleClick = n.handleClick.bind(n), n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), r(t, [{
      key: "componentWillUnmount",
      value: function value() {
        this.timeout && clearTimeout(this.timeout);
      }
    }, {
      key: "handleClick",
      value: function value(e) {
        var t = this.props,
            n = t.to,
            r = t.clickAction,
            o = t.history,
            i = this.props,
            u = i.delay,
            l = i.replace;
        u = parseInt(u, 10), l = !!l, r instanceof Function && r(), e.defaultPrevented || (e.preventDefault(), this.timeout = setTimeout(function () {
          l ? o.push.replace(n) : o.push(n);
        }, u));
      }
    }, {
      key: "render",
      value: function value() {
        var e = Object.assign({}, this.props),
            t = this.props.children;
        return delete e.delay, o.default.createElement(u.BrowserRouter, null, o.default.createElement("div", {
          role: "link",
          onClick: this.handleClick,
          onKeyPress: this.handleClick
        }, t));
      }
    }]), t;
  }(o.default.Component);

  a.propTypes = {
    delay: i.default.number,
    replace: i.default.bool,
    to: i.default.string,
    history: i.default.oneOfType([i.default.object]),
    children: i.default.oneOfType([i.default.element]),
    clickAction: i.default.oneOfType([i.default.func])
  }, a.defaultProps = {
    delay: 0,
    replace: !1,
    to: "",
    history: {},
    children: null,
    clickAction: function clickAction() {}
  }, t.default = (0, u.withRouter)(a);
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  e.exports = n(3)();
}, function (e, t, n) {
  "use strict";

  var r = n(4);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, t, n, o, i, u) {
      if (u !== r) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t) {
  e.exports = require("react-router-dom");
}]);